import { combineReducers } from "redux";
import appSliceReducer from "./reducer";
import authReducer from "../views/Auth/store/reducer";
import basicReducer from "../views/Basics/store/reducer";
import dashboardReducer from "../views/Dashboard/store/reducer";
import documentsReducer from "../views/Documents/store/reducer";
import distributionReducer from "../views/Distribution/store/reducer";
import familyReducer from "../views/Family/store/reducer";
import guardianReducer from "../views/Guardians/store/reducer";
import executorReducer from "../views/Executor/store/reducer";
import poaReducer from "../views/POA/store/reducer";
import poaCareReducer from "../views/POACare/store/reducer";
import { plansReducer } from "../views/MyPlans/UpgradeStore";
import metadataReducer from "../views/Dashboard/MetadataStore/metadataSlice";

import types from "./types";

const appReducer = combineReducers({
  app: appSliceReducer,
  auth: authReducer,
  basic: basicReducer,
  dashboard: dashboardReducer,
  document: documentsReducer,
  distribution: distributionReducer,
  family: familyReducer,
  guardian: guardianReducer,
  executor: executorReducer,
  poa: poaReducer,
  poaCare: poaCareReducer,
  plans: plansReducer,
  metadata: metadataReducer,
});

const Reducer = (state, action) => {
  if (action.type === types.LOGOUT) {
    try {
      window.localStorage.removeItem("persist:root");
    } catch (e) {}
    state = undefined;
  }
  return appReducer(state, action);
};

export default Reducer;
